export default __webpack_public_path__ + "static/media/Background.5974ec06.svg";